import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const SSOHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);

      const token = params.get("token");
      const id = params.get("id");
      const company_id = params.get("company_id");
      const user = params.get("user")
      const access = params.get("access");

      console.log("SSO Params:", { token, id, company_id });

      if (!token) throw new Error("Invalid SSO Request");

    
      const encodedUser = JSON.parse(user);
      const encodedAccess = JSON.parse(access);

      console.log(encodedAccess, "access");

      
      Cookies.set("token", token);
      Cookies.set("company_id", company_id);
      Cookies.set("userID", id);

      Cookies.set("user", JSON.stringify(encodedUser));
      Cookies.set("access", JSON.stringify(encodedAccess));

      
      navigate("/Profile", { replace: true });

    } catch (error) {
      console.error("SSO Error:", error);

      
      Cookies.remove("token");
      Cookies.remove("company_id");
      Cookies.remove("userID");
      Cookies.remove("user");
      Cookies.remove("access");

      navigate("/", { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h3>Logging you in via SSO...</h3>
    </div>
  );
};

export default SSOHandler;